import { colors, Tag, useStyles } from 'bold-ui'
import { CustomSelectFieldProps, SelectField } from 'components/form/core'
import { CiapCidSelectModel, getDescricao } from 'components/form/field/select/CiapCidSelectField/CiapCidSelectField'
import { GrupoCondicaoSelectFieldDocument } from 'graphql/hooks.generated'
import {
  GrupoCondicaoEnum,
  GrupoCondicaoSelectFieldQuery,
  GrupoCondicaoSelectFieldQueryVariables,
} from 'graphql/types.generated'
import { CSSProperties } from 'react'
import { grupoCondicao } from 'types/enums'

import { DEFAULT_SELECT_PAGE_PARAM, useAsyncQuerySelect } from '../useAsyncQuerySelect'

export interface GrupoCondicaoSelectModel {
  id: ID
  grupo: GrupoCondicaoEnum
  ciaps?: ReadonlyArray<CiapCidSelectModel>
  cids?: ReadonlyArray<CiapCidSelectModel>
}

type GrupoCondicaoSelectFieldProps = DistributiveOmit<CustomSelectFieldProps<GrupoCondicaoSelectModel>, 'itemIsEqual'>

export function GrupoCondicaoSelectField(props: Readonly<GrupoCondicaoSelectFieldProps>) {
  const { classes } = useStyles(createStyles)

  const extractItems = (data: GrupoCondicaoSelectFieldQuery) => {
    return data?.grupos?.content
  }

  const handleItemToString = (item: GrupoCondicaoSelectModel) => {
    return `${grupoCondicao[item?.grupo]}`
  }

  const handleRenderItem = (item: GrupoCondicaoSelectModel) => {
    const ciapList: string[] = []
    const cidList: string[] = []

    item.ciaps?.forEach((i) => {
      ciapList.push(`${i.codigo} ${getDescricao(i)}`)
    })
    item.cids?.forEach((i) => {
      cidList.push(`${i.codigo} ${getDescricao(i)}`)
    })

    return (
      <div className={classes.listItem}>
        <Tag style={classes.itemTag}>
          <span>{grupoCondicao[item.grupo]}</span>
        </Tag>
        {ciapList.length !== 0 && `CIAP2: ${ciapList.join(', ')};`}
        {ciapList.length !== 0 && cidList.length !== 0 && ' | '}
        {cidList.length !== 0 && `CID10: ${cidList.join(', ')};`}
      </div>
    )
  }

  const variables = (inputQuery: string): GrupoCondicaoSelectFieldQueryVariables => ({
    inputGrupo: {
      query: inputQuery,
      pageParams: {
        ...DEFAULT_SELECT_PAGE_PARAM,
        sort: ['nomeGrupo'],
        size: 25,
      },
    },
  })

  const { selectProps } = useAsyncQuerySelect<
    GrupoCondicaoSelectModel,
    GrupoCondicaoSelectFieldQuery,
    GrupoCondicaoSelectFieldQueryVariables
  >({
    query: GrupoCondicaoSelectFieldDocument,
    extractItems,
    variables,
  })

  return (
    <SelectField<GrupoCondicaoSelectModel>
      itemToString={handleItemToString}
      renderItem={handleRenderItem}
      itemIsEqual={(a: GrupoCondicaoSelectModel, b: GrupoCondicaoSelectModel) => a?.grupo === b?.grupo}
      {...selectProps}
      {...props}
    />
  )
}

const createStyles = () => ({
  listItem: {
    padding: '1px 1px 2px 2px',
    maxHeight: '2.6rem',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    WebkitLineClamp: 2,
    WebkitFlexWrap: 'nowrap',
    width: '100%',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    MozBoxOrient: 'vertical',
  } as CSSProperties,
  itemTag: {
    backgroundColor: colors.blue.c80,
    marginRight: '5px',
  } as CSSProperties,
})
